/* ==========================================================================
   NuBest header v2.1 — behaviour for
     sections/nb-announcement.liquid  (message rotation, "scroll to email signup" jump)
     sections/nb-header.liquid        (desktop panels, mobile menu drawer, hide-on-scroll, cart badge)
   Loaded (defer) by snippets/header.liquid only when Theme settings → "NuBest header v2.1" is on.

   Notes
   - Drawer open/close is the theme's own core (T4SThemeSP.Drawer, global.js). This file never opens or closes a
     drawer by itself: it listens to the "#nbh-menu-drawer-open / -close" events the core dispatches, and, to hand off
     to another theme drawer (account, search), it closes the menu through its [data-drawer-close] button and then
     clicks the matching header trigger once the close transition is done.
   - Plain ES5 on purpose (older iOS Safari).
   - Safe to run twice: every element is initialised once; the Theme editor re-initialises a section on
     "shopify:section:load".
   ========================================================================== */
(function () {
  'use strict';

  if (window.NBHeader && window.NBHeader.version) { window.NBHeader.init(document); return; }

  var d = document;
  var w = window;
  var HANDOFF_MS = 380;           // theme drawer transition is .26s for our drawer; wait for its transitionend cleanup

  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function mq(q) { return w.matchMedia ? w.matchMedia(q) : { matches: false, addListener: function () {} }; }
  function onMq(m, fn) { if (m.addEventListener) { m.addEventListener('change', fn); } else if (m.addListener) { m.addListener(fn); } }

  var mobileMq = mq('(max-width: 1023.98px)');
  var reduceMq = mq('(prefers-reduced-motion: reduce)');
  var tinyMq = mq('(max-width: 359.98px)');
  function isMobile() { return mobileMq.matches; }

  /* ───────────────────────── State (one header per page) ───────────────────────── */
  var S = {
    wrap: null,         // #shopify-section-nb-header
    header: null,       // .nbh-header
    drawer: null,       // #nbh-menu-drawer (moved to <body>)
    scrim: null,
    burger: null,
    openName: null,     // open desktop panel
    lastTrigger: null,
    drawerOpen: false,
    levelOpener: null,
    skipFocusReturn: false,
    hydrated: false,
    lastY: 0,
    ft: null,
    cartObserver: null
  };
  var bound = false;

  /* ───────────────────────── Desktop panels ───────────────────────── */
  function triggersFor(name) { return S.header ? $$('[data-nbh-trigger="' + name + '"]', S.header) : []; }
  function panelFor(name) { return S.header ? $('[data-nbh-panel="' + name + '"]', S.header) : null; }
  function setExpanded(name, on) {
    triggersFor(name).forEach(function (t) { t.setAttribute('aria-expanded', on ? 'true' : 'false'); });
  }

  function positionDrop(panel) {
    var drop = $('.nbh-drop', panel);
    if (!drop) return;
    var trig = d.getElementById(drop.getAttribute('data-nbh-anchor') || '');
    var wrap = drop.parentNode;
    if (!trig || !wrap) return;
    var wr = wrap.getBoundingClientRect();
    var tr = trig.getBoundingClientRect();
    var cs = w.getComputedStyle(wrap);
    var padL = parseFloat(cs.paddingLeft) || 0;
    var padR = parseFloat(cs.paddingRight) || 0;
    var maxLeft = wr.width - drop.offsetWidth - padR;
    drop.style.left = Math.max(padL, Math.min(tr.left - wr.left, maxLeft)) + 'px';
  }

  // A scrollable panel never extends past the viewport, whatever the header's current offset
  // (at scroll top the announcement bar sits above the sticky header).
  function fitPanel() {
    if (!S.openName || !S.header) return;
    var p = panelFor(S.openName);
    if (!p || p.className.indexOf('nbh-panel-mega') === -1) return;
    var hb = S.header.getBoundingClientRect().bottom;
    p.style.maxHeight = Math.max(220, Math.floor(w.innerHeight - hb)) + 'px';
  }
  function fitPanelSoon() { clearTimeout(S.ft); S.ft = setTimeout(fitPanel, 40); }

  function openPanel(name, opts) {
    opts = opts || {};
    if (isMobile() || !S.header) return;
    var p = panelFor(name);
    if (!p) return;
    if (S.openName && S.openName !== name) closePanel({ keepScrim: true, noFocus: true });
    p.classList.add('is-open');
    setExpanded(name, true);
    if (S.scrim) S.scrim.classList.add('is-on');
    S.openName = name;
    S.lastTrigger = opts.trigger || triggersFor(name)[0] || null;
    if (name.indexOf('dd-') === 0) positionDrop(p);
    fitPanel();
    if (!opts.noFocus) {
      setTimeout(function () {
        var first = $('a[href]', p) || $('button', p);
        if (first && S.openName === name) first.focus();
      }, 30);
    }
  }

  function closePanel(opts) {
    opts = opts || {};
    if (!S.openName) return;
    var name = S.openName;
    var p = panelFor(name);
    if (p) { p.classList.remove('is-open'); p.style.maxHeight = ''; }
    setExpanded(name, false);
    if (!opts.keepScrim && S.scrim) S.scrim.classList.remove('is-on');
    var t = S.lastTrigger;
    S.openName = null;
    S.lastTrigger = null;
    if (!opts.noFocus && t && t.focus) t.focus();
  }

  /* ───────────────────────── Mobile menu drawer ───────────────────────── */
  function showLevel(name) {
    if (!S.drawer) return;
    $$('.nbh-drawer-level', S.drawer).forEach(function (l) {
      l.classList.toggle('is-active', l.getAttribute('data-nbh-level') === name);
    });
    $$('[data-nbh-sub]', S.drawer).forEach(function (b) {
      b.setAttribute('aria-expanded', b.getAttribute('data-nbh-sub') === name ? 'true' : 'false');
    });
  }

  function focusActiveLevel() {
    if (!S.drawer) return;
    var f = $('.nbh-drawer-level.is-active .nbh-back', S.drawer) || $('.nbh-drawer-level.is-active [data-drawer-close]', S.drawer);
    if (f) f.focus();
  }

  // Mobile images load the first time the menu opens (closed-menu page loads never download them)
  function hydrateImages() {
    if (S.hydrated || !S.drawer) return;
    S.hydrated = true;
    $$('img[data-nbh-src]', S.drawer).forEach(function (img) {
      var ss = img.getAttribute('data-nbh-srcset');
      if (ss) {
        img.setAttribute('sizes', (img.getAttribute('width') || '280') + 'px');
        img.setAttribute('srcset', ss);
      }
      img.setAttribute('src', img.getAttribute('data-nbh-src'));
      img.removeAttribute('data-nbh-src');
      img.removeAttribute('data-nbh-srcset');
    });
  }

  function onDrawerOpen() {
    S.drawerOpen = true;
    if (S.openName) closePanel({ noFocus: true });
    if (S.burger) {
      S.burger.setAttribute('aria-expanded', 'true');
      var lc = S.burger.getAttribute('data-label-close');
      if (lc) S.burger.setAttribute('aria-label', lc);
    }
    showLevel('root');
    hydrateImages();
    setTimeout(focusActiveLevel, 40);
  }

  function onDrawerClose() {
    S.drawerOpen = false;
    if (S.burger) {
      S.burger.setAttribute('aria-expanded', 'false');
      var lo = S.burger.getAttribute('data-label-open');
      if (lo) S.burger.setAttribute('aria-label', lo);
    }
    S.levelOpener = null;
    var skip = S.skipFocusReturn;
    S.skipFocusReturn = false;
    // reset to the first level once the slide-out is over, so the panel does not flip while leaving
    setTimeout(function () { if (!S.drawerOpen) showLevel('root'); }, 320);
    if (!skip && S.burger && isMobile()) S.burger.focus();
  }

  function closeMenuDrawer() {
    if (!S.drawer || S.drawer.getAttribute('aria-hidden') === 'true') return;
    var b = $('[data-drawer-close]', S.drawer);
    if (b) b.click();
  }

  // Close the menu, then open another theme drawer through its header trigger (the theme core ignores an
  // "open" while another drawer is still closing, so we wait for the close transition).
  function handoff(selector) {
    S.skipFocusReturn = true;
    closeMenuDrawer();
    setTimeout(function () {
      var t = S.header ? $('[data-drawer-options*="' + selector + '"]', S.header) : null;
      if (t) { t.click(); return; }
      if (w.jQuery_T4NT && w.T4SThemeSP && w.T4SThemeSP.Drawer && w.T4SThemeSP.Drawer.opend) {
        w.T4SThemeSP.Drawer.opend(w.jQuery_T4NT(selector));
      }
    }, HANDOFF_MS);
  }

  function trapTab(e) {
    if (e.key !== 'Tab' || !S.drawerOpen || !S.drawer) return;
    var f = $$('.nbh-drawer-level.is-active a[href], .nbh-drawer-level.is-active button:not([disabled])', S.drawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0];
    var last = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ───────────────────────── Hide the header on scroll down (phones and tablets) ───────────────────────── */
  function onScroll() {
    fitPanelSoon();
    if (!S.wrap || !S.header) return;
    var y = w.pageYOffset || d.documentElement.scrollTop || 0;
    var enabled = S.header.getAttribute('data-hide-on-scroll') === 'true';
    var busy = S.openName || S.drawerOpen || d.body.classList.contains('is--opend-drawer');
    if (!enabled || !isMobile() || busy) {
      S.wrap.classList.remove('nbh-hidden');
      S.lastY = y;
      return;
    }
    var dy = y - S.lastY;
    if (y > 140 && dy > 8) S.wrap.classList.add('nbh-hidden');
    else if (dy < -8 || y <= 140) S.wrap.classList.remove('nbh-hidden');
    S.lastY = y;
  }

  /* ───────────────────────── Cart badge (theme JS writes the number into [data-cart-count]) ───────────────────────── */
  function syncCount(el) {
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    el.hidden = !(n > 0);
  }
  function watchCart() {
    if (S.cartObserver) { S.cartObserver.disconnect(); S.cartObserver = null; }
    if (!S.header) return;
    var el = $('[data-cart-count]', S.header);
    if (!el) return;
    syncCount(el);
    if (w.MutationObserver) {
      S.cartObserver = new MutationObserver(function () { syncCount(el); });
      S.cartObserver.observe(el, { childList: true, characterData: true, subtree: true });
    }
  }

  /* ───────────────────────── Header init ───────────────────────── */
  function initHeader() {
    var header = $('[data-nbh-header]');
    if (!header) { S.header = null; return; }
    S.header = header;
    S.wrap = header.closest ? header.closest('.shopify-section') || header.parentNode : header.parentNode;
    S.scrim = $('.nbh-scrim', S.wrap) || $('#nbh-scrim');
    S.burger = $('[data-nbh-burger]', header);

    var dr = d.getElementById('nbh-menu-drawer');
    if (dr) {
      var stale = $$('#nbh-menu-drawer');
      stale.forEach(function (x) { if (x !== dr && x.parentNode) x.parentNode.removeChild(x); });
      if (dr.parentNode !== d.body) d.body.appendChild(dr);
    }
    S.drawer = dr;
    S.hydrated = false;
    S.openName = null;
    S.drawerOpen = false;
    S.levelOpener = null;

    // Panels: reset (Theme editor re-render)
    $$('.nbh-panel.is-open', header).forEach(function (p) { p.classList.remove('is-open'); });
    watchCart();
    S.lastY = w.pageYOffset || 0;
  }

  /* ───────────────────────── Announcement ───────────────────────── */
  var ann = { root: null, msgs: [], i: 0, timer: null, paused: false };

  function annShow(n) {
    if (!ann.msgs.length) return;
    ann.i = (n + ann.msgs.length) % ann.msgs.length;
    ann.msgs.forEach(function (m, k) {
      var on = k === ann.i;
      m.classList.toggle('is-active', on);
      m.setAttribute('aria-hidden', on ? 'false' : 'true');
      var a = $('a', m);
      if (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }
    });
  }
  function annStop() { if (ann.timer) { clearInterval(ann.timer); ann.timer = null; } }
  function annStart() {
    annStop();
    if (!ann.root || ann.msgs.length < 2) return;
    if (reduceMq.matches || d.hidden || tinyMq.matches || ann.paused) return;
    var ms = parseInt(ann.root.getAttribute('data-interval'), 10) || 6000;
    ann.timer = setInterval(function () { annShow(ann.i + 1); }, ms);
  }

  function initAnnouncement() {
    annStop();
    var root = $('[data-nbh-announce]');
    ann.root = root;
    ann.msgs = root ? $$('.nbh-ann-msg', root) : [];
    ann.i = 0;
    ann.paused = false;
    if (!root) return;
    annShow(0);
    annStart();
  }

  function jumpToSignup(e) {
    var a = e.target.closest ? e.target.closest('[data-nbh-jump]') : null;
    if (!a) return;
    var root = a.closest('[data-nbh-announce]');
    var sel = root ? root.getAttribute('data-signup-selector') : '';
    var found = null;
    if (sel) {
      try {
        var list = d.querySelectorAll(sel);
        for (var k = 0; k < list.length; k++) {
          var el = list[k];
          if (el.offsetWidth || el.offsetHeight || (el.getClientRects && el.getClientRects().length)) { found = el; break; }
        }
      } catch (err) { found = null; }
    }
    if (!found) return;                 // no signup field on this page: follow the fallback link
    e.preventDefault();
    found.scrollIntoView({ behavior: reduceMq.matches ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () { try { found.focus({ preventScroll: true }); } catch (err2) { found.focus(); } }, reduceMq.matches ? 0 : 500);
  }

  /* ───────────────────────── One-time document wiring ───────────────────────── */
  function bindOnce() {
    if (bound) return;
    bound = true;

    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // announcement jump
      if (t.closest('[data-nbh-jump]')) { jumpToSignup(e); return; }

      if (!S.header && !S.drawer) return;

      // desktop panel triggers
      var trig = S.header ? t.closest('[data-nbh-trigger]') : null;
      if (trig && S.header.contains(trig)) {
        var name = trig.getAttribute('data-nbh-trigger');
        if (S.openName === name) closePanel(); else openPanel(name, { trigger: trig });
        return;
      }
      var closeBtn = S.header ? t.closest('[data-nbh-close]') : null;
      if (closeBtn) { closePanel(); return; }
      if (S.scrim && t === S.scrim) { closePanel(); return; }

      // drawer: levels, back, accordions, hand-off rows
      if (S.drawer && S.drawer.contains(t)) {
        var sub = t.closest('[data-nbh-sub]');
        if (sub) { S.levelOpener = sub; showLevel(sub.getAttribute('data-nbh-sub')); setTimeout(focusActiveLevel, 30); return; }
        var back = t.closest('[data-nbh-back]');
        if (back) {
          showLevel('root');
          var o = S.levelOpener; S.levelOpener = null;
          setTimeout(function () { var f = o || $('[data-nbh-sub]', S.drawer); if (f) f.focus(); }, 30);
          return;
        }
        var acc = t.closest('.nbh-acc-btn');
        if (acc) {
          var open = acc.getAttribute('aria-expanded') === 'true';
          acc.setAttribute('aria-expanded', open ? 'false' : 'true');
          var body = d.getElementById(acc.getAttribute('aria-controls'));
          if (body) body.hidden = open;
          return;
        }
        var ho = t.closest('[data-nbh-open]');
        if (ho) { e.preventDefault(); handoff(ho.getAttribute('data-nbh-open')); return; }
      }
    });

    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { if (S.openName && !S.drawerOpen) closePanel(); return; }
      trapTab(e);
    });

    // Focus leaving the header while a panel is open closes it
    d.addEventListener('focusin', function (e) {
      if (!S.openName || !S.header) return;
      if (!S.header.contains(e.target)) closePanel({ noFocus: true });
    });

    d.addEventListener('nbh-menu-drawer-open', onDrawerOpen);
    d.addEventListener('nbh-menu-drawer-close', onDrawerClose);

    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', function () {
      fitPanelSoon();
      if (S.openName && S.openName.indexOf('dd-') === 0) { var p = panelFor(S.openName); if (p) positionDrop(p); }
    });
    onMq(mobileMq, function () {
      if (isMobile()) closePanel({ noFocus: true }); else { S.skipFocusReturn = true; closeMenuDrawer(); }
      if (S.wrap) S.wrap.classList.remove('nbh-hidden');
    });

    // announcement: pause on hover/focus, stop on hidden tab / reduced motion / very narrow screens
    d.addEventListener('mouseover', function (e) { if (ann.root && ann.root.contains(e.target) && !ann.paused) { ann.paused = true; annStop(); } });
    d.addEventListener('mouseout', function (e) {
      if (!ann.root || !ann.paused) return;
      if (ann.root.contains(e.target) && !(e.relatedTarget && ann.root.contains(e.relatedTarget))) { ann.paused = false; annStart(); }
    });
    d.addEventListener('focusin', function (e) { if (ann.root && ann.root.contains(e.target)) { ann.paused = true; annStop(); } });
    d.addEventListener('focusout', function (e) {
      if (ann.root && ann.paused && ann.root.contains(e.target) && !(e.relatedTarget && ann.root.contains(e.relatedTarget))) { ann.paused = false; annStart(); }
    });
    d.addEventListener('visibilitychange', function () { if (d.hidden) annStop(); else annStart(); });
    onMq(reduceMq, annStart);
    onMq(tinyMq, annStart);

    // Theme editor
    d.addEventListener('shopify:section:load', function (e) {
      var id = e.detail && e.detail.sectionId;
      if (id === 'nb-header') initHeader();
      if (id === 'nb-announcement') initAnnouncement();
    });
    d.addEventListener('shopify:section:unload', function (e) {
      var id = e.detail && e.detail.sectionId;
      if (id === 'nb-announcement') annStop();
      if (id === 'nb-header') { if (S.cartObserver) S.cartObserver.disconnect(); closePanel({ noFocus: true }); }
    });
  }

  function init() {
    bindOnce();
    initHeader();
    initAnnouncement();
  }

  w.NBHeader = { version: 21, init: init, openPanel: openPanel, closePanel: closePanel, state: S, announce: ann };

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
